import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import ForbiddenIcon from "mdi-material-ui/Cancel";
import classnames from "classnames";

import { translate } from "jazasoft";

const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      height: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
      marginTop: "-3em"
    }
  },
  icon: {
    width: "9em",
    height: "9em",
    color: 'red'
  },
  message: {
    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    opacity: 0.5,
    margin: "0 1em"
  },
  toolbar: {
    textAlign: "center",
    marginTop: "2em"
  }
});

const Forbidden = ({ classes, className, translate, title, history, match, location, staticContext, ...rest }) => (
  <div className={classnames(classes.container, className)}>
    <div className={classes.message}>
      <ForbiddenIcon className={classes.icon} />
      <h1>Forbidden</h1>
      <h2>You are not authorized to acces this application.</h2>
    </div>
  </div>
);

Forbidden.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  translate: PropTypes.func.isRequired
};

export default translate(withStyles(styles)(Forbidden));
